<script>
import CrudListVue from 'Support/components/crud/CrudList.vue';
import DataTableDateColumnVue from 'Support/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import LotesPurchaseRequest from 'Domain/financial/LotesPurchaseRequest';
import DataTableCurrencyColumnVue from 'Support/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import RepurchaseStatusColumnVue from './RepurchaseStatusColumn.vue';
import SituacaoPagamentoColumnVue from './SituacaoPagamentoColumn.vue';

export default {
  name: 'LotesPurchaseList',
  extends: CrudListVue,
  data: () => ({
    hideDelete: true,
    editRoute: 'RepurchaseLoteList',
    requestClass: LotesPurchaseRequest,
    customEditIcon: 'visibility',
    headers: [
      {
        text: 'Usuário',
        value: 'usuarioCadastroNome',
      },
      {
        text: 'ID Transação TED',
        value: 'pagamentoTransactionId',
      },
      {
        text: 'Situação da recompra',
        value: 'status',
        component: RepurchaseStatusColumnVue,
      },
      {
        text: 'Situação pagamento',
        value: 'situacaoPagamento',
        component: SituacaoPagamentoColumnVue,
      },
      {
        text: 'Total',
        value: 'valorTotal',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Data da conclusão',
        value: 'dataDaConclusao',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
